module.exports = __webpack_public_path__ + "img/hrmprofiletest.ec9ef0ae.png";